var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#6A7878"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM8.1155 10.25C7.90267 10.25 7.72442 10.3218 7.58075 10.4655C7.43725 10.609 7.3655 10.7872 7.3655 11V16C7.3655 16.2128 7.43725 16.391 7.58075 16.5345C7.72442 16.6782 7.90267 16.75 8.1155 16.75C8.32817 16.75 8.50633 16.6782 8.65 16.5345C8.7935 16.391 8.86525 16.2128 8.86525 16V11C8.86525 10.7872 8.7935 10.609 8.65 10.4655C8.50633 10.3218 8.32817 10.25 8.1155 10.25ZM12 7.25C11.7872 7.25 11.609 7.32183 11.4655 7.4655C11.3218 7.609 11.25 7.78717 11.25 8V16C11.25 16.2128 11.3218 16.391 11.4655 16.5345C11.609 16.6782 11.7872 16.75 12 16.75C12.2128 16.75 12.391 16.6782 12.5345 16.5345C12.6782 16.391 12.75 16.2128 12.75 16V8C12.75 7.78717 12.6782 7.609 12.5345 7.4655C12.391 7.32183 12.2128 7.25 12 7.25ZM15.8845 13.25C15.6718 13.25 15.4937 13.3218 15.35 13.4655C15.2065 13.609 15.1348 13.7872 15.1348 14V16C15.1348 16.2128 15.2065 16.391 15.35 16.5345C15.4937 16.6782 15.6718 16.75 15.8845 16.75C16.0973 16.75 16.2756 16.6782 16.4193 16.5345C16.5628 16.391 16.6345 16.2128 16.6345 16V14C16.6345 13.7872 16.5628 13.609 16.4193 13.4655C16.2756 13.3218 16.0973 13.25 15.8845 13.25Z",
    fill: "#6A7878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertChart);
export default __webpack_public_path__ + "static/media/insert_chart.24e739e6f784611683a2b064e1d81c1c.svg";
export { ForwardRef as ReactComponent };